import { useQuery } from '@tanstack/react-query';
import {
  AirtableStatus,
  TYPESENSE_COLLECTION,
} from 'gatsby-theme-hem-store/src/constants';
import uniq from 'lodash/uniq';

export const useCategories = (
  categoriesLvl0: string,
  categoriesLvl1: string,
) => {
  const { data, status } = useQuery({
    queryKey: ['product-recommendations-tabs', categoriesLvl0, categoriesLvl1],
    queryFn: async () => {
      const url = `https://${process.env.GATSBY_TYPESENSE_HOST}:${process.env.GATSBY_TYPESENSE_PORT}/multi_search`;
      const options = {
        method: 'POST',
        headers: {
          'X-Typesense-Api-Key': process.env.GATSBY_TYPESENSE_SEARCH_KEY,
        },
        body: JSON.stringify({
          searches: [
            {
              collection: TYPESENSE_COLLECTION,
              q: '*',
              per_page: 0,
              filter_by: [
                'tags:!=[secret,algolia-ignore]',
                'type:=variant',
                `status:!=${AirtableStatus.PRE_ORDER}`,
                categoriesLvl0
                  ? `categories.lvl1:=${categoriesLvl0} > ${categoriesLvl1}`
                  : `categories.lvl0:=${categoriesLvl1}`,
              ].join(' && '),
              facet_by: categoriesLvl0 ? 'categories.lvl2' : 'categories.lvl1',
              sort_by: 'priority:desc',
              exclude_fields: 'embedding',
            },
          ],
        }),
      };

      const response = await fetch(url, options);
      const result = await response.json();
      const categories = result.results[0].facet_counts[0].counts.map(
        (facet: { value: string }) => facet.value,
      );

      return uniq(
        categories.map((category: string) => category.split('>').pop().trim()),
      ) as string[];
    },
  });

  return { data, status };
};
